<template>
  <div class="custom-attr" style="background: #fff;">
    <div class="content">
      <div class="content-text">
        <p class="content-title">模型自定义属性<span class="subtitle">（自定义的属性自动写入到模型中）</span></p>
        <div class="subtitle"></div>
      </div>
    </div>
    <div class="content-details">
      <div class="type-area">
        <el-radio v-model="type" label="1" @input="onTypeChange">自定义属性</el-radio>
        <el-radio v-model="type" label="2" @input="onTypeChange">配置特定属性</el-radio>
        <el-radio v-model="type" label="3" @input="onTypeChange">自定义+配置特定</el-radio>
      </div>
      <div class="attr-title">
        <div class="input-group">
          <div class="header-item">属性名称</div>
          <div class="header-item">属性值</div>
        </div>
        <div class="btn-group"></div>
      </div>
      <div style="padding: 10px 20px;">
        <div class="content-row" v-for="(item, index) in list" :key="index" style="margin-bottom: 8px;">
          <div class="input-group">
            <el-input v-if="item.editing" v-model="item.name" size="small" placeholder="请输入属性名称" />
            <span v-else class="text-cell">{{ item.name }}</span>
            <el-input v-if="item.editing" v-model="item.value" size="small" placeholder="请输入属性值" />
            <span v-else class="text-cell">{{ item.value }}</span>
          </div>
          <div class="btn-group">
            <el-button size="small" @click="toggleEdit(index)" style="margin-right: 8px;">{{ item.editing ? '保存' : '编辑' }}</el-button>
            <el-button size="small" type="danger" @click="item.editing ? cancelEdit(index) : removeItem(index)">{{ item.editing ? '取消' : '删除' }}</el-button>
          </div>
        </div>
        <div class="content-row" style="margin-top: 10px;">
          <el-button size="small" type="primary" plain @click="addItem" style="font-size: 14px;"><i class="el-icon-plus" style="margin-right: 10px;"></i>新增</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {WinForm} from '@/libs/winform';

export default {
  props: {
  },
  data() {
    return {
      list: [],
      storgeKey: 'model_custom_attr',
      type: '1', // 1-自定义属性 2-配置特定属性 3-自定义+配置特定

    }
  },
  mounted() {
    this.getModelAttr();
  },
  computed: {
    hasEditing() {
      return this.list.some(item => item.editing)
    },
    maxReached() {
      return this.list.length >= 5
    }
  },
  methods: {
    // 获取modelset
    getModelAttr() {
        const data = WinForm.storge.get(this.storgeKey);
        this.type = data && data.length > 0 ? (data[0].type || '1') : '1';
        this.list = data || [];
    },
    addItem() {
      if (this.hasEditing) {
        this.$message.warning('您正在编辑中，请先保存或取消当前编辑')
        return
      }
      if (this.maxReached) {
        this.$message.warning('最多允许添加5行')
        return
      }
      this.list.push({ name: '', value: '', editing: true, isNew: true })
    },
    removeItem(index) {
      this.list.splice(index, 1);
      WinForm.storge.set(this.storgeKey, this.list)
    },
    toggleEdit(index) {
      const item = this.list[index]
      if (item.editing) {
        // 保存
        item.editing = false
        item.isNew = false
      } else {
        // 进入编辑，备份原始值
        item.editing = true
        item._backup = { name: item.name, value: item.value }
      }
      const data = this.list.map((item) => {
        item.type = this.type;
        return item;
      })
      WinForm.storge.set(this.storgeKey, data)
    },
    cancelEdit(index) {
      const item = this.list[index]
      if (item.isNew) {
        this.list.splice(index, 1)
      } else {
        item.editing = false
        item.name = item._backup.name
        item.value = item._backup.value
      }
    },
    onTypeChange(val) {
      if(this.list.length === 0) {
        return;
      }
      const data = this.list
        .filter(item => !item.editing)
        .map((item) => {
          item.type = val;
          return item;
        })
      WinForm.storge.set(this.storgeKey, data)
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  display: flex;
  padding: 14px 20px;
  align-items: center;
}
.subtitle {
    color: #888;
    font-size: 12px; 
    line-height: 20px;
}
.content-details {
    padding: 10px 30px;
    .type-area {
      padding-bottom: 20px;
    }
  .attr-title{
    display: flex;
    align-items: center;
    background: #f7f7f7;
    line-height: 28px;
    padding: 10px 20px;
    font-size: 14px;
    .input-group {
      display: flex;
      align-items: center;
      flex: 1;
      gap: 40px;
    }
    .header-item {
       flex: 1;
        max-width: 500px;
    }
  }
  .content-row {
    display: flex;
    align-items: center;
  }
  .input-group {
    display: flex;
    align-items: center;
    flex: 1;
    gap: 40px;
    .el-input {
      flex: 1;
      max-width: 500px;
    }
    .text-cell {
      flex: 1;
      max-width: 500px;
      line-height: 32px;
      color: #333;
    }
  }
  .btn-group {
    flex-shrink: 0;
    margin-left: 40px;
    width: 130px;
  }
}
</style>
